import { InfoDisplayField } from './InfoDisplayField';
import { useNextPaymentPeriodField } from './hooks/useNextPaymentPeriodField';

export const NextPaymentPeriodField = () => {
    const { label, value } = useNextPaymentPeriodField();

    return <InfoDisplayField label={label} value={value} />;
};
